enum Mhd2Permissions {
    appointmentManagement = "RD2.Appointments.Manage",
    appointmentView = "RD2.Appointments.View",
    orderManagement = "RD2.Orders.Manage",
    orderView = "RD2.Orders.View",
    patientManagement = "RD2.Patients.Manage",
    patientView = "RD2.Patients.View",
    calendarScheduleManagement = "RD2.CalendarSchedule.Manage",
	calendarScheduleView = "RD2.CalendarSchedule.View"
}

export default Mhd2Permissions;